// document.addEventListener('DOMContentLoaded', () => {
	const vimeoBlocks = document.querySelectorAll('.thumbnail--non-custom-vimeo');

	vimeoBlocks.forEach(block => {
		const img = block as HTMLImageElement;
		const videoUrl = img.closest('.videoGrid__video')?.getAttribute('data-mfp-src');
		const match = videoUrl?.match(/(?:vimeo\.com\/(?:video\/)?)(\d+)/);

		if (match && match[1]) {
			const videoId = match[1];

			fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoId}`)
				.then(response => response.json())
				.then(data => {
					if (img && data.thumbnail_url) {
						img.src = data.thumbnail_url;
					}
				})
				.catch(error => {
					console.error('Error fetching Vimeo thumbnail:', error);
				});
		}
	});
// });
